module.exports = __webpack_public_path__ + "img/gdgd.8b65ff0b.png";